<script>
import topMenu from '@/components/brand/components/topMenu';
import {createNamespacedHelpers} from "vuex";

const {mapGetters, mapActions} = createNamespacedHelpers('brand/info')
export default {
  name: "BrandError",
  components: {
    topMenu
  },
  data() {
    return {
      brandId: this.$route.params.id,
      showOverlay: 0,
    }
  },
  methods: {
    ...mapActions([
      'GET_ERRORS',
    ]),
  },
  computed: {
    ...mapGetters([
      'BRAND_ERRORS',
      'IS_BRAND_ERRORS',
    ]),
    errors() {
      return this.BRAND_ERRORS.errors
    },
  },
  created() {
    if (this.IS_BRAND_ERRORS !== this.brandId) {
      this.GET_ERRORS({id: this.brandId, th: this});
      this.$store.commit('brand/info/IS_BRAND_ERRORS', this.brandId);
    }
  }
}
</script>

<template>
  <div>
    <top-menu v-bind:sale-id="brandId"></top-menu>
    <b-overlay :show="showOverlay > 0" class="overlay" rounded="lg">
      <b-container fluid class="mb-3">
        <b-row class="mb-5">
          <b-col>
            <table class="table table-hover table-striped">
              <tbody>
                <tr v-for="(error, index) in errors" :key="index">
                  <td class="px-2">
                    <strong>
                      {{ nFormat(error.value) }}
                    </strong>
                  </td>
                  <td class="px-2">
                    <strong>
                      {{ error.ratio }} <span v-if="error.ratio">%</span>
                    </strong>
                  </td>
                  <td class="px-2 text-left">
                    <strong>
                      {{ error.title }}
                    </strong>
                  </td>
                  <td class="px-2 text-left">
                    {{ error.description }}
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<style scoped>

</style>